import { observer } from "mobx-react"

import { Checkbox, Stack } from "@mui/material"

import { CheckBox, CheckBoxOutlineBlank } from "@material-ui/icons"

import { useCallback } from "react"

import { t } from "@lingui/macro"

import { useStore } from "src/store/lib/useStore"
import { CommunityInsightsStore } from "src/views/community-insights/store"
import { ICommunity } from "src/views/community-insights/types"
import { popperStyled } from "src/views/community-insights/components/styles"
import { AutoCompleteTextField } from "src/components/AutoCompleteTextField"

const icon = <CheckBoxOutlineBlank fontSize="small" />
const checkedIcon = <CheckBox fontSize="small" />

export const MultiselectAutocomplete = observer(() => {
    const store = useStore(CommunityInsightsStore)

    const handleSearchChange = useCallback(
        (option: ICommunity[]) => {
            const selectedCommunities = option.map((option) => option.id)
            store.setSelectedCommunities(selectedCommunities)
        },
        [store],
    )

    const renderOption = useCallback((props, option, { selected }) => {
        const { ...optionProps } = props
        return (
            <li key={option.id} {...optionProps}>
                <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                />
                {option.internal_name} ({option.id})
            </li>
        )
    }, [])

    const handleChange = useCallback(
        (_event, value) => {
            // For multiselect, value will be an array, but handle all cases for type safety
            const communities = Array.isArray(value) ? value : []
            handleSearchChange(communities)
        },
        [handleSearchChange],
    )

    return (
        <Stack maxHeight={56} style={{ position: "relative" }}>
            <AutoCompleteTextField
                multiple
                id="community-insights-checkboxes-autocomplete"
                limitTags={2}
                options={store.allCommunities}
                disableCloseOnSelect
                getOptionLabel={(option) => option.internal_name}
                onChange={handleChange}
                renderOption={renderOption}
                style={{ width: 500, zIndex: 1 }}
                PopperComponent={popperStyled}
                label={t`community-insights.search-field-placeholder`}
                placeholder={t`community-insights.search-field-placeholder`}
            />
        </Stack>
    )
})
